import React from 'react';
import PropTypes from 'prop-types';
import { initials } from '../../utils/text';

// `.avatar` circle with the person's initials. size → sm | lg (default is the
// base 36px). Pass `text` instead of `name` when the label isn't a person's
// name (the feed uses "OK" / "A1"). `.avatar` is inline-flex, so the span
// renders identically to the divs some call sites used before.
export default function Avatar({ name, text, size, className, ...rest }) {
  return (
    <span className={['avatar', size, className].filter(Boolean).join(' ')} {...rest}>
      {text != null ? text : initials(name)}
    </span>
  );
}

Avatar.propTypes = {
  name: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
  className: PropTypes.string,
};
